/**
 * Decides whether /ccn/callback should start the CUBEforall sign-in by itself.
 *
 * A user who arrives from the CUBE portal (Products tile or a document link)
 * has no JARVIS session yet. In redirect mode the whole tab can go to
 * Microsoft and come straight back, so showing a "sign in" button first is
 * one click of pure friction. Two guards keep this from looping:
 * - not on the return leg (the URL still carries Microsoft's answer and the
 *   SDK is parsing it), and
 * - not already attempted in this tab (a cancelled or failed sign-in ends at
 *   the button, never in a redirect loop).
 */
export const CCN_AUTO_LOGIN_KEY = 'ccn_auto_login_attempted';

/** True when the URL carries Microsoft's answer to a redirect sign-in. */
export const isCubeReturnLeg = (hash: string, search: string): boolean =>
  /(^|[#&?])(code|id_token|state|error|error_description)=/.test(`${hash}${search}`);

export const shouldAutoStartRedirectLogin = (input: {
  loginType: string;
  returnLeg: boolean;
  attempted: boolean;
}): boolean => input.loginType === 'redirect' && !input.returnLeg && !input.attempted;

export const readAutoLoginAttempted = (): boolean => {
  try {
    return sessionStorage.getItem(CCN_AUTO_LOGIN_KEY) === '1';
  } catch {
    return true; // no storage → never auto-start, fall back to the button
  }
};

export const markAutoLoginAttempted = (): void => {
  try {
    sessionStorage.setItem(CCN_AUTO_LOGIN_KEY, '1');
  } catch {
    // ignore
  }
};

export const clearAutoLoginAttempted = (): void => {
  try {
    sessionStorage.removeItem(CCN_AUTO_LOGIN_KEY);
  } catch {
    // ignore
  }
};
